var _defs, _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.45 319.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#231f20;}.cls-3{fill:#812990;}.cls-4{fill:#6b7b84;}.cls-5{fill:none;stroke:#ffcb05;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 382.9,
    y1: 301.35,
    x2: 425.32,
    y2: 301.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "382.9 319.02 404.11 283.67 425.32 319.02 382.9 319.02"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.54,283.94h-.6v1.67H85.6v-1.67H85v-.35h1.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M88.71,283.59v2h-.35v-1.43l-.67,1-.66-1v1.43h-.35v-2h.38l.63,1,.64-1Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M33.18,288.84v.65a4.66,4.66,0,0,0-1.15-.62,4.27,4.27,0,0,0-1.49-.24,4.49,4.49,0,0,0-1.74.33,4.28,4.28,0,0,0-1.38.92,4.21,4.21,0,0,0-.91,1.37,4.27,4.27,0,0,0-.33,1.68,4.2,4.2,0,0,0,.33,1.66,4.19,4.19,0,0,0,2.29,2.29,4.32,4.32,0,0,0,1.74.34h.17a4.67,4.67,0,0,0,1.76-.33v-2.32h0a2.31,2.31,0,0,1-.81.51,2.66,2.66,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2.61,2.61,0,0,1-.55-.14,2.11,2.11,0,0,1-.8-.51,2.26,2.26,0,0,1,0-3.31,2.38,2.38,0,0,1,.8-.51,2.55,2.55,0,0,1,.95-.18,2.43,2.43,0,0,1,1.75.69,2.21,2.21,0,0,1,.72,1.66v4.29h2.06v-8.38Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24.46,297.22l-4.56-4.41v4.41H17.84V285.61H19.9V290l4.56-4.37h2.92l-6,5.78,6,5.81Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.59,288.63a3.8,3.8,0,0,1,1.53.3,3.55,3.55,0,0,1,1.18.83,4.06,4.06,0,0,1,.75,1.23,4.16,4.16,0,0,1,.27,1.5v4.73H42.26v-4.73a1.74,1.74,0,0,0-.6-1.35,2.07,2.07,0,0,0-2.83,0,1.8,1.8,0,0,0-.59,1.35v4.73H36.18v-8.36h2.06v.62a3.9,3.9,0,0,1,1-.61A3.38,3.38,0,0,1,40.59,288.63Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.5,288.86a3.57,3.57,0,0,1,1.38-.25v2a2.48,2.48,0,0,0-1.75.68,2.28,2.28,0,0,0-.72,1.66v4.31H65.35v-8.38h2.06v.64A4.47,4.47,0,0,1,68.5,288.86Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M74.54,288.63a4.72,4.72,0,0,1,1.77.33,4.67,4.67,0,0,1,1.44.92,4.38,4.38,0,0,1,1,1.37,4.11,4.11,0,0,1,.35,1.68,4.05,4.05,0,0,1-.35,1.66,4.27,4.27,0,0,1-1,1.37,4.49,4.49,0,0,1-1.44.92,4.54,4.54,0,0,1-1.77.34,4.45,4.45,0,0,1-1.76-.34,4.65,4.65,0,0,1-1.45-.92,4.43,4.43,0,0,1-1-1.37,4.05,4.05,0,0,1-.35-1.66,4.11,4.11,0,0,1,.35-1.68,4.55,4.55,0,0,1,1-1.37,4.84,4.84,0,0,1,1.45-.92A4.63,4.63,0,0,1,74.54,288.63Zm0,1.95a2.45,2.45,0,0,0-1.75.69,2.26,2.26,0,0,0,0,3.31,2.19,2.19,0,0,0,.8.51,2.74,2.74,0,0,0,1.9,0,2.37,2.37,0,0,0,.8-.51,2.26,2.26,0,0,0,0-3.31A2.5,2.5,0,0,0,74.54,290.58Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M84.18,288.63a4.63,4.63,0,0,1,1.76.33,4.84,4.84,0,0,1,1.45.92,4.55,4.55,0,0,1,1,1.37,4.11,4.11,0,0,1,.35,1.68,4.05,4.05,0,0,1-.35,1.66,4.43,4.43,0,0,1-1,1.37,4.65,4.65,0,0,1-1.45.92,4.45,4.45,0,0,1-1.76.34,4.54,4.54,0,0,1-1.77-.34A4.49,4.49,0,0,1,81,296a4.27,4.27,0,0,1-1-1.37,3.9,3.9,0,0,1-.35-1.66,4,4,0,0,1,.35-1.68,4.38,4.38,0,0,1,1-1.37,4.67,4.67,0,0,1,1.44-.92A4.72,4.72,0,0,1,84.18,288.63Zm0,1.95a2.43,2.43,0,0,0-1.75.69,2.26,2.26,0,0,0,0,3.31,2.11,2.11,0,0,0,.8.51,2.75,2.75,0,0,0,1,.17,2.7,2.7,0,0,0,.94-.17,2.31,2.31,0,0,0,.81-.51,2.26,2.26,0,0,0,0-3.31A2.53,2.53,0,0,0,84.18,290.58Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M62.16,288.84v.65a5,5,0,0,0-1.15-.62,4.37,4.37,0,0,0-1.5-.24,4.53,4.53,0,0,0-1.74.33,4.19,4.19,0,0,0-2.29,2.29,4.26,4.26,0,0,0-.32,1.68,4.2,4.2,0,0,0,.32,1.66,4.19,4.19,0,0,0,2.29,2.29,4.36,4.36,0,0,0,1.74.34h.18a4.62,4.62,0,0,0,1.75-.33v-2.32h0a2.31,2.31,0,0,1-.81.51,2.7,2.7,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2.7,2.7,0,0,1-.56-.14,2.07,2.07,0,0,1-.79-.51,2.26,2.26,0,0,1,0-3.31,2.34,2.34,0,0,1,.79-.51,2.6,2.6,0,0,1,1-.18,2.45,2.45,0,0,1,1.75.69,2.21,2.21,0,0,1,.72,1.66v4.29h2.06v-8.38Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M52.18,288.84v.65a5,5,0,0,0-1.15-.62,4.12,4.12,0,0,0-.75-.18,4.88,4.88,0,0,0-.88-.08,4.18,4.18,0,0,0-1.71.34,4,4,0,0,0-1.34.92,4.33,4.33,0,0,0-.87,1.37,4.62,4.62,0,0,0-.3,1.67h0a4.2,4.2,0,0,0,.32,1.66,4.19,4.19,0,0,0,2.29,2.29,4.32,4.32,0,0,0,1.74.34h.31a4.58,4.58,0,0,0,1.62-.32v-2.32h0a2.31,2.31,0,0,1-.81.51,2.7,2.7,0,0,1-.94.17,2.6,2.6,0,0,1-.4,0h0a2.7,2.7,0,0,1-.56-.14,2.07,2.07,0,0,1-.79-.51,2.31,2.31,0,0,1-.56-2.52l0-.07a2.39,2.39,0,0,1,.53-.72,2.34,2.34,0,0,1,.79-.51,2.6,2.6,0,0,1,1-.18,2.46,2.46,0,0,1,1.75.69A2.53,2.53,0,0,1,52,292l0,.07a2.29,2.29,0,0,1,.17.87v3.26a2.21,2.21,0,0,1-.72,1.65,2.42,2.42,0,0,1-1.75.7,2.37,2.37,0,0,1-1.24-.33L47,299.61a4.6,4.6,0,0,0,2.73.88,4.52,4.52,0,0,0,1.76-.34,4.69,4.69,0,0,0,1.44-.93,4.12,4.12,0,0,0,1-1.37,3.9,3.9,0,0,0,.36-1.66v-7.35Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.23,304.3v.55H17.84v-3.12h2.3v.55H18.46v.79h1.41v.53H18.46v.7Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.18,301.48v3.33h-.62v-.15a1.32,1.32,0,0,1-.69.19,1.25,1.25,0,0,1,0-2.49,1.35,1.35,0,0,1,.69.19v-1.07Zm-.62,2.6v-1a.9.9,0,0,0-.58-.2.68.68,0,0,0-.72.69.67.67,0,0,0,.72.68A.86.86,0,0,0,23.56,304.08Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M28.11,302.41v2.4H27.5v-.16a1.14,1.14,0,0,1-.66.2c-.7,0-1-.33-1-1.11v-1.33h.62v1.33c0,.38.18.56.52.56a.85.85,0,0,0,.55-.19v-1.7Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.9,304.37a1.18,1.18,0,0,1-.93.48,1.24,1.24,0,1,1,0-2.48,1.12,1.12,0,0,1,.93.48l-.39.36a.67.67,0,0,0-.54-.29.69.69,0,1,0,0,1.38.66.66,0,0,0,.54-.3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.84,302.41v2.4h-.62v-.17a1.28,1.28,0,0,1-.7.21,1.25,1.25,0,0,1,0-2.49,1.39,1.39,0,0,1,.7.2v-.15Zm-.62.72a.9.9,0,0,0-.59-.21.69.69,0,1,0,0,1.38.9.9,0,0,0,.59-.21Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38.25,302.92v.85c0,.43.07.55.38.55l.28,0v.46a1.48,1.48,0,0,1-.56.09.69.69,0,0,1-.72-.76v-1.17h-.34v-.51h.34v-.93h.62v.93h.67v.51Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M40.39,301.83a.35.35,0,1,1,.35.36A.36.36,0,0,1,40.39,301.83Zm0,.62h.62v2.4h-.62Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.23,303.61a1.31,1.31,0,1,1-1.31-1.24A1.28,1.28,0,0,1,45.23,303.61Zm-.6,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,44.63,303.61Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49.06,303.51v1.34h-.61v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4h.62v.15a1,1,0,0,1,.64-.2C48.74,302.4,49.06,302.73,49.06,303.51Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M53.89,302.28v1.11h1.49v.55H53.89v.91h-.62v-3.12h2.35v.55Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M59.59,303.61a1.31,1.31,0,1,1-1.31-1.24A1.28,1.28,0,0,1,59.59,303.61Zm-.6,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,59,303.61Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63.41,302.41v2.4h-.62v-.16a1.09,1.09,0,0,1-.65.2c-.7,0-1-.33-1-1.11v-1.33h.62v1.33c0,.38.18.56.52.56a.81.81,0,0,0,.54-.19v-1.7Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.35,303.51v1.34h-.61v-1.34c0-.37-.18-.55-.52-.55a.76.76,0,0,0-.53.19v1.7h-.62v-2.4h.62v.15a1,1,0,0,1,.64-.2C67,302.4,67.35,302.73,67.35,303.51Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.41,301.48v3.33h-.62v-.15a1.33,1.33,0,0,1-.7.19,1.25,1.25,0,0,1,0-2.49,1.36,1.36,0,0,1,.7.19v-1.07Zm-.62,2.6v-1a.9.9,0,0,0-.58-.2.68.68,0,0,0-.72.69.67.67,0,0,0,.72.68A.86.86,0,0,0,70.79,304.08Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.48,302.41v2.4h-.61v-.17a1.29,1.29,0,0,1-.71.21,1.25,1.25,0,0,1,0-2.49,1.46,1.46,0,0,1,.71.2v-.15Zm-.61.72a.93.93,0,0,0-.6-.21.69.69,0,1,0,0,1.38.91.91,0,0,0,.6-.21Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.89,302.92v.85c0,.43.07.55.38.55l.28,0v.46a1.4,1.4,0,0,1-.55.09.69.69,0,0,1-.73-.76v-1.17h-.34v-.51h.34v-.93h.62v.93h.67v.51Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M80,301.83a.36.36,0,0,1,.36-.36.36.36,0,0,1,0,.72A.36.36,0,0,1,80,301.83Zm0,.62h.61v2.4h-.61Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M84.88,303.61a1.32,1.32,0,1,1-1.32-1.24A1.28,1.28,0,0,1,84.88,303.61Zm-.61,0a.71.71,0,1,0-.71.69A.7.7,0,0,0,84.27,303.61Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.71,303.51v1.34h-.62v-1.34c0-.37-.18-.55-.52-.55a.78.78,0,0,0-.53.19v1.7h-.61v-2.4H87v.15a1.08,1.08,0,0,1,.64-.2C88.38,302.4,88.71,302.73,88.71,303.51Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 425.32,
    y2: 0.13
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 319.02
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 354.46,
    y1: 0.13,
    x2: 354.46,
    y2: 319.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 35.56,
    y1: 0.13,
    x2: 35.56,
    y2: 319.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 70.99,
    y1: 0.13,
    x2: 70.99,
    y2: 319.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 106.42,
    y1: 0.13,
    x2: 106.42,
    y2: 319.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 141.86,
    y1: 0.13,
    x2: 141.86,
    y2: 319.02
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 177.29,
    y1: 0.13,
    x2: 177.29,
    y2: 319.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 212.72,
    y1: 0.13,
    x2: 212.72,
    y2: 319.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 248.16,
    y1: 0.13,
    x2: 248.16,
    y2: 319.02
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 283.59,
    y1: 0.13,
    x2: 283.59,
    y2: 319.02
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 319.02,
    y1: 0.13,
    x2: 319.02,
    y2: 319.02
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 17.84,
    y1: 0.13,
    x2: 17.84,
    y2: 319.02
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 53.27,
    y1: 0.13,
    x2: 53.27,
    y2: 319.02
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 88.71,
    y1: 0.13,
    x2: 88.71,
    y2: 319.02
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 124.14,
    y1: 0.13,
    x2: 124.14,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 159.57,
    y1: 0.13,
    x2: 159.57,
    y2: 319.02
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 195.01,
    y1: 0.13,
    x2: 195.01,
    y2: 319.02
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 230.44,
    y1: 0.13,
    x2: 230.44,
    y2: 319.02
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 265.87,
    y1: 0.13,
    x2: 265.87,
    y2: 319.02
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 301.31,
    y1: 0.13,
    x2: 301.31,
    y2: 319.02
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 336.74,
    y1: 0.13,
    x2: 336.74,
    y2: 319.02
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 319.02,
    x2: 425.32,
    y2: 319.02
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 283.59,
    x2: 425.32,
    y2: 283.59
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 248.16,
    x2: 425.32,
    y2: 248.16
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 212.72,
    x2: 425.32,
    y2: 212.72
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 177.29,
    x2: 425.32,
    y2: 177.29
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 141.86,
    x2: 425.32,
    y2: 141.86
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 106.42,
    x2: 425.32,
    y2: 106.42
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 70.99,
    x2: 425.32,
    y2: 70.99
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 35.56,
    x2: 425.32,
    y2: 35.56
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 301.31,
    x2: 425.32,
    y2: 301.31
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 265.87,
    x2: 425.32,
    y2: 265.87
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 230.44,
    x2: 425.32,
    y2: 230.44
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.12,
    y1: 195.01,
    x2: 425.32,
    y2: 195.01
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 159.57,
    x2: 425.32,
    y2: 159.57
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 124.14,
    x2: 425.32,
    y2: 124.14
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 88.71,
    x2: 425.32,
    y2: 88.71
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 53.27,
    x2: 425.32,
    y2: 53.27
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 0.13,
    y1: 17.84,
    x2: 425.32,
    y2: 17.84
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 389.89,
    y1: 0.13,
    x2: 389.89,
    y2: 319.02
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 425.32,
    y1: 0.13,
    x2: 425.32,
    y2: 319.02
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 372.17,
    y1: 0.13,
    x2: 372.17,
    y2: 319.02
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 407.61,
    y1: 0.13,
    x2: 407.61,
    y2: 319.02
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial16);
export default __webpack_public_path__ + "static/media/guideMaterial16.34db59059e0ecd0d76439ec281bb1eb3.svg";
export { ForwardRef as ReactComponent };